var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["menu-wrap", _vm.collapse ? "menu-collapse" : ""],
      on: {
        mouseenter: function($event) {
          _vm.handleCollapseMenu(false)
        },
        mouseleave: function($event) {
          _vm.handleCollapseMenu(true)
        }
      }
    },
    [
      _vm.isServicePage
        ? _c(
            "div",
            { staticClass: "menu-header" },
            [
              _c(
                "div",
                { staticClass: "backmap" },
                [
                  _c("router-link", { attrs: { to: "/app/myapp" } }, [
                    _vm._v("\n        < 返回\n      ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.getAppName || "尚未设置",
                    placement: "right"
                  }
                },
                [
                  _c("div", { staticClass: "ellipsis" }, [
                    _vm._v(_vm._s(_vm.getAppName || "尚未设置"))
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "menu-content" },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.getMenu,
                collapse: _vm.collapse,
                "unique-opened": true
              }
            },
            [
              _vm._l(_vm.menuData, function(menuItem, index) {
                return [
                  menuItem.submenu && menuItem.submenu.length > 0
                    ? _c(
                        "el-submenu",
                        { key: index + "", attrs: { index: index + "" } },
                        [
                          _c(
                            "template",
                            { attrs: { slot: "title" }, slot: "title" },
                            [
                              _c(
                                "div",
                                { staticStyle: { overflow: "hidden" } },
                                [
                                  _c(
                                    "svg",
                                    { staticClass: "icon icon-business" },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": menuItem.icon }
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    _vm._s(menuItem.title) + "\n            "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(menuItem.submenu, function(submenuItem) {
                            return [
                              !submenuItem.external
                                ? _c(
                                    "router-link",
                                    {
                                      key: submenuItem.key,
                                      attrs: { to: submenuItem.path }
                                    },
                                    [
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: submenuItem.key } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "submenuItem-title"
                                            },
                                            [_vm._v(_vm._s(submenuItem.title))]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "a",
                                    {
                                      key: submenuItem.key,
                                      attrs: {
                                        target: "_blank",
                                        href: submenuItem.path
                                      }
                                    },
                                    [
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: submenuItem.key } },
                                        [
                                          _c("div", [
                                            _vm._v(_vm._s(submenuItem.title))
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                            ]
                          })
                        ],
                        2
                      )
                    : [
                        !menuItem.external
                          ? _c(
                              "router-link",
                              {
                                key: menuItem.key || index + "",
                                staticClass: "leaf-submenu",
                                attrs: { to: menuItem.path }
                              },
                              [
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: { index: menuItem.key || index + "" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { overflow: "hidden" } },
                                      [
                                        _c(
                                          "svg",
                                          { staticClass: "icon icon-business" },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href": menuItem.icon
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(
                                          _vm._s(menuItem.title) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _c(
                              "a",
                              {
                                key: menuItem.key || index + "",
                                staticClass: "leaf-submenu",
                                attrs: { target: "_blank", href: menuItem.path }
                              },
                              [
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: { index: menuItem.key || index + "" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { overflow: "hidden" } },
                                      [
                                        _c(
                                          "svg",
                                          { staticClass: "icon icon-business" },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href": menuItem.icon
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(
                                          _vm._s(menuItem.title) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                      ]
                ]
              }),
              _vm._v(" "),
              !_vm.collapse && _vm.getHistoryServices.length > 0
                ? _c("router-link", { attrs: { to: "/services/history" } }, [
                    _c("div", { staticClass: "to-history" }, [
                      _vm._v("历史服务列表")
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34194c8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34194c8e","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/SideBar/Main.vue
// module id = 756
// module chunks = 40